import React from 'react';
// import Page500 from "./Page500";
import { compose } from "redux";
import { connect } from "react-redux";
import axios from 'axios';
import * as Sentry from "@sentry/react";
import { Button, Typography } from "@material-ui/core";
// import {withTranslation} from "react-i18next";
import { NavLink } from 'react-router-dom';
import logoClient from '../../images/navbar/logo2.png'
import * as links from "../../constants/links"
import Banner from '../../components/Banner';
import {withTranslation} from "react-i18next";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        })
        try {
            const payload = {
                message: error && error.message ? error.message : String(error),
                stack: error && error.stack ? error.stack : null,
                componentStack: errorInfo ? errorInfo.componentStack : null,
                url: (typeof window !== 'undefined' && window.location) ? window.location.href : null,
                userAgent: (typeof navigator !== 'undefined') ? navigator.userAgent : null,
                timestamp: new Date().toISOString()
            };
            // send to backend logging endpoint (uses axios baseURL if configured)
            axios.post('/api/client-error', payload).catch(() => { });
        } catch (e) {
            // swallow any error in the logger to avoid infinite loops
        }

        // forward to Sentry if available
        try {
            if (Sentry && typeof Sentry.captureException === 'function') {
                Sentry.captureException(error);
            }
        } catch (e) {
            // ignore
        }
    }

    resetErrorBoundary() {
        this.setState({
            error: null,
            errorInfo: null
        });
    }

    render() {
        if (this.state.errorInfo) {
            // show friendly error UI with retry
            return (
                <div style={{

                }}>
                    <div style={{
                        height: '60px',
                        padding: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: '#fff'
                    }}>
                        <NavLink to={links.HOME}><img src={logoClient} alt={'logo'} /></NavLink>
                    </div>
                    <Banner />
                    <div style={{
                        textAlign: 'center',
                        padding: '2rem',
                    }}>
                        <Typography variant="h4" style={{ marginBottom: '1rem' }}>{this.props.t('errors.hasError')}</Typography>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
                            <Button variant="contained" color="primary" onClick={() => {
                                // reset boundary, then reload to ensure a clean state
                                this.resetErrorBoundary();
                                try { window.location.reload(); } catch (e) { }
                            }}>{this.props.t('label.reloadPage')}</Button>
                            <Button variant="outlined" color="default" onClick={() => {
                                if (typeof this.resetErrorBoundary === 'function') this.resetErrorBoundary();
                                try { window.location.replace('/'); } catch (e) { }
                            }}>{this.props.t('label.goToHome')}</Button>
                        </div>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}


export default compose(
    withTranslation()
)(ErrorBoundary);
